import { EpisodeV4 } from "@/types/MentionCard";

export async function getTiktokEmbed(episodeUrl: EpisodeV4["public_url"]) {
  return fetch(
    `https://www.tiktok.com/oembed?url=${encodeURIComponent(episodeUrl)}`,
    {
      method: "GET",
    }
  ).then((r) => r.json());
}
